// src/socket.js
import { io } from "socket.io-client";
  import { SOCKET_URL } from "../constants/Constant";
import { toast } from "react-toastify";
let connect = false;
let connection = false;
let socket = null;


let pendingEvents = {
  devices: [],
  zones: []
}

const recentLiveNotificationIds = new Set();
const MAX_LIVE_NOTIFICATION_MEMORY = 200;

const markNotificationRead = (socket, userId, notificationId) => {
  if (!notificationId) {
    return;
  }
  socket.emit('notification_view', {
    notificationId,
    userId,
  });
};

const rememberLiveNotification = (notificationId) => {
  if (!notificationId) {
    return false;
  }
  const id = String(notificationId);
  if (recentLiveNotificationIds.has(id)) {
    return true;
  }
  recentLiveNotificationIds.add(id);
  if (recentLiveNotificationIds.size > MAX_LIVE_NOTIFICATION_MEMORY) {
    const oldest = recentLiveNotificationIds.values().next().value;
    recentLiveNotificationIds.delete(oldest);
  }
  return false;
};

const getToken = () => localStorage.getItem("token");

const initializeSocket = (token) => {
  socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ["websocket"],
    auth: { token },
  });
};

const socketFunc = (devices = null, zones = null, callback) => {
  // if (connect === true && devices == null) {
  //   return;
  // }

  const token = getToken();

  // If token is not ready, retry in 300ms
  if (!token) {
    console.warn("Token not ready, retrying socket setup...");
    setTimeout(() => socketFunc(devices, zones, callback), 300);
    return;
  }

  // Initialize socket only once
  if (!socket) initializeSocket(token);



  if (connect === false) {
    socket.connect();
    socket.on("connect", () => {
      console.log("Connected to socket server");
      connection = true

      pendingEvents.devices.forEach((device) => {
        socket.on("device_status_" + device._id.toString(), function (data) {
          callback(data);
        })
      })

    });
    const data = decodeJWT(token);
    if (devices == null) {
      socket.on("notification_" + data.id, ({ message, _id }) => {
        if (rememberLiveNotification(_id)) {
          return;
        }
        toast.success("Notification: " + message);
        markNotificationRead(socket, data.id, _id);
      });

      socket.on("old_notification_" + data.id, ({ notifications }) => {
        if (!notifications?.length) {
          return;
        }
        const unread = notifications.filter((item) => item?.status === 0 || item?.status == null);
        const batch = unread.length ? unread : notifications;
        if (batch.length === 1) {
          toast.success("Notification: " + batch[0].message);
          markNotificationRead(socket, data.id, batch[0]._id);
          return;
        }
        toast.info(
          `You have ${batch.length} unread alerts (zones, battery, trips). Latest: ${batch[0].message}`
        );
        batch.forEach((item) => markNotificationRead(socket, data.id, item._id));
      });
    }




  }
  connect = true;


  if (devices && devices.length > 0) {
    if (connection === true) {
      devices.forEach((device) => {
        socket.on("device_status_" + device._id.toString(), function (data) {
          callback(data);
        })
      })
    } else {
      pendingEvents.devices = devices;
    }

  }


}

export default socketFunc;

const decodeJWT = (token) => {
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid JWT');
  }

  const payload = parts[1];
  const decodedPayload = JSON.parse(atob(payload));
  return decodedPayload;
}
